import { QueryClient } from 'react-query';

// a singleton is fine since we have no SSR
export const queryClient = new QueryClient();
